module.exports = __webpack_public_path__ + "img/ic_32_profile_problem.8342c64b.svg";